import { render, staticRenderFns } from "./supplier-edit.vue?vue&type=template&id=643385c4&scoped=true&"
import script from "./supplier-edit.vue?vue&type=script&lang=js&"
export * from "./supplier-edit.vue?vue&type=script&lang=js&"
import style0 from "./supplier-edit.vue?vue&type=style&index=0&id=643385c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643385c4",
  null
  
)

export default component.exports